import React, { useState, useEffect } from 'react';
import request from '../services/Request';
import { Button, Box, Typography, Chip, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LoadingIcon from '../frontend/items/buttons/LoadingIcon';
import BackButton from '../frontend/items/buttons/BackButton';
import ComputerIcon from '@mui/icons-material/Computer';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import Swal from 'sweetalert2';
import { userLimits } from '../frontend/dashboard/uitls/userLimits';
import DownloadIcon from '@mui/icons-material/Download';
import { ExportToCsv } from 'export-to-csv';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import BoxPlanoModal from './BoxPlano/boxPlanoModal';
import CreatePlanoModal from './CreatePlanoModal';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../frontend/dashboard/components/ModernTable';
import GridOnIcon from '@mui/icons-material/GridOn';
import AddIcon from '@mui/icons-material/Add';

const getPlanoByEmailURL = `/plano/getPlanoByEmail/`;
const CreatePlanoURL = `/plano/create`;
const CreateTCNPlanoURL = `/TCNplano/create`;
const DeletePlanoURL = `/plano/`;
const DeleteTCNPlanoURL = `/TCNplano/`;
const UpdateNameURL = `/plano/name/`;
const getMyMachinesURL = `/machines/getMyMachines/`;

export default function ViewMyPlano(props) {
  const theme = useTheme();
  const { id, tableTitle, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Planograms',
    'edit_plano'
  );

  const modelsToCheck = ['Gamma', 'Inspire', 'Delta', 'SmartBox', `Zeta`];

  const MagexModel = [
    {
      name: 'Colosseo',
      lane: 18,
      floor: 6,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 16,
    },
    {
      name: 'Big Store',
      lane: 14,
      floor: 6,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 19,
    },
    {
      name: 'Easy 14',
      lane: 14,
      floor: 6,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 16,
    },
    {
      name: 'Easy 9',
      lane: 9,
      floor: 6,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 16,
    },
    {
      name: 'Arena 9',
      lane: 9,
      floor: 6,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 19,
    },
    {
      name: 'Idea 9',
      lane: 9,
      floor: 6,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 16,
    },
    {
      name: 'Idea 6',
      lane: 6,
      floor: 6,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 16,
    },
  ];

  const theModel = [
    {
      name: 'Gamma 13',
      floor: 7,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 16,
      width: 158,
      depth: 53,
      divider: 1.7,
      min_width: 3,
      min_height: 13.5,
    },
    {
      name: 'Gamma 10',
      floor: 7,
      laneLength: 7.8,
      height: 85,
      slot_height: 2.54,
      step_depth: 2.4,
      step_num: 16,
      width: 158,
      depth: 53,
      divider: 1.7,
      min_width: 3,
      min_height: 13.5,
    },
    {
      name: 'Inspire 10',
      lane: 10,
      floor: 7,
      laneLength: 7.8,
      height: 114,
      width: 101,
      depth: 51,
      divider: 1.7,
      min_width: 3,
      min_height: 13.5,
    },
    {
      name: 'Delta 7',
      lane: 7,
      floor: 7,
      laneLength: 7.8,
      height: 121,
      width: 69,
      depth: 44,
      divider: 1.7,
      min_width: 3,
      min_height: 13.5,
    },
    {
      name: 'SmartBox',
      lane: 15,
      floor: 7,
      laneLength: 7.8,
      height: 142,
      width: 106,
      depth: 24,
      divider: 1.7,
      min_width: 3,
      min_height: 13.5,
    },
    {
      name: 'Zeta 2',
      lane: 3,
      floor: 5,
      laneLength: 7.8,
      height: 72,
      width: 75,
      depth: 51,
      divider: 0.1,
      min_width: 3,
      min_height: 13.5,
    },
  ];

  const [planos, setPlanos] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [reflesh, setReflesh] = useState(false);
  const [machines, setMachines] = useState([]);

  const [showBox, setShowBox] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_plano') ? localStorage.getItem('table_view_plano') : 10
  );

  useEffect(() => {
    localStorage.setItem('table_view_plano', pagination);
  }, [pagination]);

  const functionToRun = (e) => {
    e.preventDefault();
    reflesh ? setReflesh(false) : setReflesh(true);
    return;
  };

  useEffect(() => {
    window.addEventListener('storage', functionToRun);
    return () => {
      window.removeEventListener('storage', functionToRun);
    };
  });

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getPlanos() {
      request({
        method: 'get',
        url: getPlanoByEmailURL + id,
      }).then((res) => {
        if (!isCancelled) {
          // console.log('planos', res.data);
          setPlanos(res.data);
          setIsLoading(true);
        }
      });
    }

    async function getMyMachines() {
      request({
        method: 'get',
        url: getMyMachinesURL + id,
      }).then((res) => {
        if (!isCancelled) {
          setMachines(res.data);
          // console.log('machines', res.data);
          setIsLoading(true);
        }
      });
    }

    getPlanos();
    getMyMachines();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deletePlano = async (rowData, referTo) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(false);
        if (modelsToCheck.some((model) => rowData.model.includes(model))) {
          request({
            method: 'delete',
            url: DeleteTCNPlanoURL + rowData._id,
          }).then(() => {
            Swal.fire('', `Planogram ${rowData.name} has been deleted.`, 'success');
            reflesh ? setReflesh(false) : setReflesh(true);
            setIsLoading(true);
          });
        } else {
          request({
            method: 'delete',
            url: DeletePlanoURL + rowData._id,
          }).then(() => {
            Swal.fire('', `Planogram ${rowData.name} has been deleted.`, 'success');
            reflesh ? setReflesh(false) : setReflesh(true);
            setIsLoading(true);
          });
        }
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire('Cancelled', '', 'success');
      }
    });
  };

  const duplicatePlano = (rowData) => {
    if (rowData.stock === 1 && rowData.referPlano === null) {
      setIsLoading(false);
      if (modelsToCheck.some((model) => rowData.model.includes(model))) {
        request({
          method: 'post',
          url: '/plano/duplicateTCN/' + rowData?._id,
        })
          .then(() => {
            Swal.fire('Success', 'Successfully dumplicated the planogram', 'success');
            setIsLoading(true);
          })
          .catch(() => {
            Swal.fire('Fail', 'Fail to dumplicated the planogram', 'fail');
            setIsLoading(true);
          });
      } else {
        request({
          method: 'post',
          url: '/plano/duplicate/' + rowData?._id,
        })
          .then(() => {
            Swal.fire('Success', 'Successfully dumplicated the planogram', 'success');
            setIsLoading(true);
          })
          .catch(() => {
            Swal.fire('Fail', 'Fail to dumplicated the planogram', 'fail');
            setIsLoading(true);
          });
      }
    } else {
      Swal.fire('Fail', 'Planogram of Multi stocks are not supported', 'fail');
      setIsLoading(true);
    }
  };

  const downloadProductCsv = async (data) => {
    const items = data?.prods;
    let filteredItems = [];
    console.log('items', items);
    try {
      items.forEach((e) => {
        const item = {};
        item.upc = e.id?.upc;
        item.name = e.id?.name?.en;
        item.brand = e.id?.brand?.name?.en ? e.id?.brand?.name?.en : '';
        item.price = e.id?.price;
        if (e.pos) {
          const array = e.pos.split(' ');
          const indexF = array[0].indexOf('F');
          const row = parseInt(array[0].substring(0, indexF));
          const indexL = array[1].indexOf('L');
          const lane = parseInt(array[1].substring(0, indexL));
          item.floor = row;
          item.lane = lane;
        } else {
          item.slot = e.idx;
        }

        // const indexW = array[2].indexOf('W');
        // const width = parseInt(array[2].substring(0, indexW));

        // item.stock = 1;

        item.maxStock = e.max_stock;

        if (item.name) {
          filteredItems.push(item);
        }
      });
      filteredItems = filteredItems.sort((a, b) => {
        if (a.floor > b.floor) {
          return 1;
        }
        if (a.floor < b.floor) {
          return -1;
        } else {
          return a.lane - b.lane;
        }
      });
    } catch (e) {
      console.log(e);
    }

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Planogram CSV',
      useTextFile: false,
      filename: 'Planogram CSV',
      useBom: true,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(filteredItems);
  };
  const lookup = [
    ...new Set(
      machines.map((e, i) => {
        if (modelsToCheck.some((model) => e.model.includes(model))) {
          return e.model;
        } else {
          if (e.stock == 1)
            return `${e.model} (${e.lane.toString()} Lanes, ${e.floor.toString()} Floors)`;
          else {
            if (e.modelNum) {
              return `${e.model} (${e.modelNum} Stocks)` + ` + ${e.model1} (${e.modelNum1} Stocks)`;
            } else {
              return `${e.model} (${e.lane.toString()} Lanes, ${e.floor.toString()} Floors * ${
                e.stock
              } Stocks)`;
            }
          }
        }
      })
    ),
  ];

  const columns = [
    {
      title: 'Planogram Name',
      field: 'name',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
          {rowData.name}
        </Typography>
      ),
    },
    {
      title: 'Model',
      field: 'model',
      lookup: lookup,
      render: (rowData) => (
        <Chip
          label={rowData.model}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
      editable: 'onAdd',
    },
    {
      title: 'Number of Lanes',
      field: 'lineNumber',
      editable: 'never',
      type: 'numeric',
      render: (rowData) => {
        if (modelsToCheck.some((model) => rowData.model.includes(model))) {
          return <Typography variant="body2">-</Typography>;
        } else {
          return <Typography variant="body2">{rowData.lineNumber}</Typography>;
        }
      },
    },
    {
      title: 'Number of Floors',
      field: 'floorNumber',
      type: 'numeric',
      render: (rowData) => <Typography variant="body2">{rowData.floorNumber}</Typography>,
    },
  ];

  return (
    <ModernPageContainer>
      {!isloading && <LoadingIcon />}

      <ModernPageHeader
        title={tableTitle || 'Planograms'}
        subtitle="Create and manage machine planograms"
        icon={GridOnIcon}
        buttons={[
          {
            text: 'Create Planogram',
            icon: AddIcon,
            variant: 'contained',
            onClick: () => {
              if (!access) return Swal.fire('', "You don't have permission", 'error');
              setShowCreateModal(true);
            },
          },
        ]}
      />

      <Box sx={{ mt: 3 }}>
        <ModernTable
          onChangeRowsPerPage={setPagination}
          columns={columns}
          data={planos}
          parentChildData={(row, rows) => rows.find((a) => a._id === row.referPlano)}
          localization={{
            body: { editRow: { deleteText: 'Are you sure to delete this Planogram' } },
          }}
          editable={
            access && {
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setIsLoading(false);
                  setTimeout(async () => {
                    await request({
                      method: 'patch',
                      url: UpdateNameURL + newData._id,
                      data: {
                        model: newData.model,
                        name: newData.name,
                      },
                    }).then((res) => {
                      setIsLoading(true);
                      reflesh ? setReflesh(false) : setReflesh(true);
                    });
                    resolve();
                  }, 1000);
                }),
            }
          }
          actions={[
            (rowData) => ({
              icon: () => {
                return rowData.newPlano ? <FiberNewIcon /> : <ComputerIcon />;
              },
              tooltip: 'View the planogram',
              onClick: (event, rowData) => {
                if (rowData.model.includes('Gamma')) {
                  window.open(`/TCNplano/${rowData._id}/${id}`, 'TCNplanogram');
                } else if (rowData.model.includes('Inspire')) {
                  window.open(`/INSplano/${rowData._id}/${id}`, 'planogram');
                } else if (rowData.model.includes('Delta')) {
                  window.open(`/DELplano/${rowData._id}/${id}`, 'planogram');
                } else if (rowData.model.includes('SmartBox')) {
                  window.open(`/SMBplano/${rowData._id}/${id}`, 'planogram');
                } else if (rowData.model.includes('Zeta')) {
                  window.open(`/ZTplano/${rowData._id}/${id}`, 'planogram');
                } else {
                  window.open(`/plano/${rowData._id}/${id}`, 'planogram');
                }
              },
            }),
            () => ({
              icon: DownloadIcon,
              tooltip: 'Download csv',
              onClick: (event, rowData) => {
                downloadProductCsv(rowData);
              },
            }),
            (rowData) => ({
              icon: FileCopyIcon,
              tooltip: 'Duplicate the planogram',
              onClick: (event, rowData) => {
                duplicatePlano(rowData);
              },
            }),
            (rowData) =>
              access && rowData.referPlano == null
                ? {
                    icon: 'delete',
                    tooltip: 'Delete This Planogram',
                    onClick: (event, rowData) => {
                      deletePlano(rowData);
                    },
                  }
                : {
                    icon: 'blank',
                  },
            // () =>
            //   //condition
            //   true
            //     ? {
            //         icon: 'add',
            //         tooltip: 'Add Boxes to Planogram',
            //         onClick: (event, rowData) => {
            //           setShowBox(true);
            //         },
            //       }
            //     : null,
          ]}
          options={{
            actionsColumnIndex: -1,
            rowStyle: (rowData) => ({
              backgroundColor: rowData.referPlano != null ? alpha(theme.palette.grey[100], 0.5) : 'transparent',
            }),
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100],
          }}
        />

        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
      </Box>

      <BoxPlanoModal show={showBox} onHide={() => setShowBox(false)} />
      <CreatePlanoModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        id={id}
        reflesh={reflesh}
        setReflesh={setReflesh}
        machines={machines}
        modelsToCheck={modelsToCheck}
        theModel={theModel}
        MagexModel={MagexModel}
      />
    </ModernPageContainer>
  );
}
